import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MissionVision from "@/components/MissionVision";
import Philosophy from "@/components/Philosophy";
import Products from "@/components/Products";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="min-h-screen bg-[#F8F5F0] text-[#2E3A2F]">
      <Navbar />
      <Hero />
      <MissionVision />
      <Philosophy />
      <Products />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
